var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIconBgBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "phone-icon-Bg--black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy-5",
    transform: "translate(-120.000000, -9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone-icon-Bg--black",
    transform: "translate(120.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fillOpacity: 0.475897516,
    fill: "#000000",
    cx: 11,
    cy: 11,
    r: 11
  }), /*#__PURE__*/React.createElement("g", {
    id: "phone-icon--brown.d2dce4622ad01ee382edab80cef20a4e",
    transform: "translate(5.000000, 5.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.59569249,11.974804 C7.73385384,11.8558529 6.91460583,11.5419125 6.20675765,11.0593509 C5.38646223,10.5158245 4.63293726,9.88637949 3.9603517,9.18285171 C3.13418892,8.34298638 2.29289033,7.51391932 1.56384898,6.58766784 C0.989949652,5.84378712 0.476593544,5.06391217 0.196581122,4.16765588 C0.0018614303,3.59782245 -0.049125151,2.99239247 0.0477456904,2.40033926 C0.173877412,1.69365257 0.567408383,1.11894472 1.10599083,0.637821864 C1.32812284,0.448856934 1.5693692,0.281266977 1.82620297,0.137502088 C2.13871435,-0.0513472047 2.53938436,-0.0452151486 2.84534728,0.153099587 C3.56247191,0.55903888 4.11211786,1.18602572 4.40307404,1.93001467 C4.50467125,2.14348797 4.47616015,2.39263091 4.32865632,2.5803104 C4.14828796,2.81187327 3.9603517,3.0374371 3.77872202,3.26899997 C3.61853473,3.47416707 3.45204086,3.67573475 3.30951201,3.89170012 C3.15903088,4.09351076 3.16157325,4.36436985 3.3158186,4.56359239 C3.675294,5.04351543 4.02341756,5.53783617 4.41442589,5.99496287 C5.12190791,6.82803422 5.9052801,7.60010434 6.75543065,8.30219292 C6.94462823,8.45696811 7.1477003,8.59374617 7.34951105,8.73412363 C7.52505423,8.86393251 7.76401445,8.88455417 7.9612499,8.78691523 C8.17751315,8.68552329 8.38802319,8.57338646 8.59190855,8.45096907 C8.87444358,8.27939658 9.15193338,8.10302486 9.42942318,7.93385199 C9.66265903,7.79186847 9.95990083,7.78630624 10.1988267,7.91945429 C10.9144448,8.25720371 11.4978174,8.80371951 11.8637654,9.47920423 C12.0744021,9.8246022 12.0382366,10.2579693 11.7729505,10.5674297 C11.0754421,11.43849 10.1836908,11.9760039 8.99805266,12 C8.8635684,11.998139 8.72927255,11.9897293 8.59569249,11.974804 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconBgBlack);
export default __webpack_public_path__ + "static/media/phone-icon-Bg--black.6c4cca6b2ab33213e00f5b6b19003587.svg";
export { ForwardRef as ReactComponent };